import React, { useEffect } from 'react';

import ImageMobile from '../../assets/svg/panelImageMobile2.svg';
import Image from '../../assets/svg/panelImage.svg';
import Panel from '../../components/Panel';
import { gtmAttributesReceiveEmail } from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';
import { gtmAttributesUpdateConfirmationEmailPage } from '../../utils/gtmVariables';
import Typography from '../../components/Typography';

const gtmEventsTracker = useGTMEventsTracker();

const ConfirmationEmail = () => {
  gtmEventsTracker(gtmAttributesUpdateConfirmationEmailPage);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Panel
        title="Confirme o email que enviamos pra você"
        description=""
        panelType="confirmation"
        link="/resend-email"
        linkText="Não recebi o email"
        imageMobile={ImageMobile}
        image={Image}
        className="confirmation-email-panel"
        onClick={() => gtmEventsTracker(gtmAttributesReceiveEmail)}
      >
        <Typography as="p" variant="body2" className="text-neutral-darkest leading-6">
          Por favor,{' '}
          <Typography as="span" variant="subtitle2" className="leading-6">
            verifique a sua caixa de entrada e de spam.{' '}
          </Typography>
          Ao encontrar, abra o link que está no email pra confirmar que recebeu.
        </Typography>
      </Panel>
    </div>
  );
};

export default ConfirmationEmail;
